/*----------- humburger Icon -------------*/
const hamburger = document.querySelector(".hamburger");
const navMenu = document.querySelector(".navbarnav");
hamburger.addEventListener("click", () => {
  navMenu.classList.toggle("show");
  hamburger.classList.toggle("active");
  document.body.classList.toggle("overflowY-hidden");
});

/*--------- dropdown toggle --------- */
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 991) {
    const dropdownLinks = document.querySelectorAll(".dropdown-link");

    dropdownLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const dropTargetId = this.getAttribute("data-drop-target");
        const dropdownMenu = document.getElementById(dropTargetId);

        dropdownLinks.forEach(function (otherLink) {
          if (otherLink !== link) {
            const otherDropTargetId =
              otherLink.getAttribute("data-drop-target");
            const otherDropdownMenu =
              document.getElementById(otherDropTargetId);
            if (otherDropdownMenu.classList.contains("show")) {
              otherDropdownMenu.classList.remove("show");
            }
          }
        });
        dropdownMenu.classList.toggle("show");
        link.classList.toggle("active");
      });
    });
  }
});

/*--------- serach bar -----------*/
// const searchCta = document.getElementById("search-cta");
// const searchForm =document.getElementById("search-form");
// searchCta.addEventListener('click', ()=>{
//   searchForm.classList.add("show")
// })

/*--------- hero banner -----------*/
window.addEventListener("load", function () {
  $(document).ready(function () {
    var prevBtn =
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/previous.svg?v=1712565922" alt=""></button>';
    var nxtBtn =
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/next.svg?v=1712565923" alt=""></button>';

    var $slider = $(".hero-slider");
    var $currentSlide = $(".current-slide");
    var $totalSlides = $(".total-slides");

    $slider.on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $currentSlide.text(i);
        $totalSlides.text(slick.slideCount);
      }
    );

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows:true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      prevArrow: prevBtn,
      nextArrow: nxtBtn,
    });
  });

  $(".partner-carousel").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1500,
    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".shop-product-slider").slick({
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    dots: true,
    autoplay: true,
    vertical: true,
    speed: 6000,
    verticalSwiping: true,
    pauseOnHover: true,
    // cssEase: "linear",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          cssEase: false,
          autoplay: true,
          speed: false,
          verticalSwiping: false,
          pauseOnHover: false,
          arrows: true,
          prevArrow:
            '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/previous.svg?v=1712565922" alt=""></button>',
          nextArrow:
            '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/next.svg?v=1712565923" alt=""></button>',
        },
      },
    ],
  });

  $(".breathing-space-carousel").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "80px",
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/previous.svg?v=1712565922" alt=""></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/next.svg?v=1712565923" alt=""></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".testimonial-carousel").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "80px",
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/Vector_1382c1f1-9369-49d3-83ea-7f6f7ab029f1.svg" alt=""></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/Vector.svg" alt=""></button>',
  });

  $(".product-detail-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".product-detail-nav",
  });
  $(".product-detail-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    asNavFor: ".product-detail-slider",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/prev-icon.svg?v=1716445168" alt=""></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/next-icon.svg?v=1716445168" alt=""></button>',

    responsive: [
      {
        breakpoint: 991,
        settings: {
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if (window.innerWidth <= 767) {
    $(".related-products").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/previous.svg?v=1712565922" alt=""></button>',
      nextArrow:
        '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0868/8467/9999/files/next.svg?v=1712565923" alt=""></button>',
    });
  }

  /*---------Read more -----------*/
  $(document).ready(function () {
    $(".read-more").click(function (e) {
      e.preventDefault();
      var $this = $(this);
      var $content = $this.prev(".more-content");
      var isVisible = $content.is(":visible");

      $content.slideToggle(function () {
        $this.text(isVisible ? "Read More" : "Read Less");
      });
    });
  });
});

/*-------- Eye Icon -------*/
const togglePassword = document.querySelector("#togglePassword");
const password = document.querySelector("#CustomerPassword");
const reg_password = document.querySelector("#RegisterForm-password");
if (togglePassword) {
  togglePassword.addEventListener("click", function () {
    // toggle the type attribute
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);

    // toggle the icon
    this.classList.toggle("bi-eye");
  });
}
if (togglePassword) {
  togglePassword.addEventListener("click", function () {
    // toggle the type attribute
    const type =
      reg_password.getAttribute("type") === "password" ? "text" : "password";
    reg_password.setAttribute("type", type);

    // toggle the icon
    this.classList.toggle("bi-eye");
  });
}
// prevent form submit
/*
        const form = document.querySelector("form");
        form.addEventListener('submit', function (e) {
            e.preventDefault();
        });
      */

/*---------Product's Specialization-----------*/
var accordions = document.querySelectorAll(".specialization-accordion");
if (window.innerWidth >= 991) {
  accordions.forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      this.classList.toggle("show");
      accordions.forEach(function (item) {
        if (item !== accordion) {
          item.classList.remove("show");
        }
      });
    });
  });
}
if (window.innerWidth <= 991) {
  accordions.forEach(function (item) {
    item.classList.remove("show");
  });
  $(".specialization-content").slick({
    dots: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    pauseOnHover: true,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
  });
}

/*--------- faq tabs -----------*/
document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tab-link");

  tabLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      const targetId = this.getAttribute("data-bs-target");
      const targetPane = document.querySelector(targetId);

      if (targetPane) {
        document.querySelectorAll(".tab-pane").forEach(function (pane) {
          pane.classList.remove("show");
        });
        tabLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        targetPane.classList.add("show");
        this.classList.add("active");
      }
    });
  });
});

/*--------- filter tabs -----------*/
document.addEventListener("DOMContentLoaded", function () {
  const filterTabLinks = document.querySelectorAll(".filter-link");
  if (filterTabLinks) {
    filterTabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("data-bs");
        const targetPane = document.querySelector(targetId);

        if (targetPane) {
          document
            .querySelectorAll(".tab-content-col")
            .forEach(function (pane) {
              pane.classList.remove("show");
            });
          filterTabLinks.forEach(function (link) {
            link.classList.remove("active");
          });
          targetPane.classList.add("show");
          this.classList.add("active");
        }
      });
    });
    if (window.innerWidth <= 991) {
      const accImg = document.querySelectorAll(".filter-link .arrow img");
      // console.log(accImg);
      const newImageSource =
        "https://cdn.shopify.com/s/files/1/0868/8467/9999/files/arrow-down_1.svg?v=1715780670";
      accImg.forEach((img) => {
        img.src = newImageSource;
      });
    }
  }
});

/*--------- case study tabs -----------*/
document.addEventListener("DOMContentLoaded", function () {
  const caseTabLinks = document.querySelectorAll(".case-study-link");
  const caseCards = document.querySelectorAll(".case-card");

  if (caseTabLinks) {
    caseTabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("id");
        caseCards.forEach(function (card) {
          const cardTarget = card.getAttribute("data-case-target");
          if (targetId == "all-case-study") {
            card.classList.add("show");
            // console.log(card);
          } else if (cardTarget == targetId) {
            card.classList.add("show");
          } else {
            card.classList.remove("show");
          }
        });

        caseTabLinks.forEach(function (link) {
          link.classList.remove("active");
        });

        this.classList.add("active");
      });
    });
  }
});

/*--------- faq accordion -----------*/

let header = document.querySelectorAll(".accordion-header");

header.forEach((header) => {
  header.addEventListener("click", function (e) {
    let accordion = document.querySelectorAll(".accordion");
    let parentElm = header.parentElement;
    let siblings = this.nextElementSibling;
    accordion.forEach((element) => {
      element.children[1].style.maxHeight = null;
    });

    parentElm.classList.toggle("active");
    if (parentElm.classList.contains("active")) {
      accordion.forEach((element) => {
        element.classList.remove("active");
      });
      parentElm.classList.toggle("active");
      if (siblings.style.maxHeight) {
        siblings.style.maxHeight = null;
      } else {
        siblings.style.maxHeight = siblings.scrollHeight + "px";
      }
    }
  });
});

/*--------- Counter -----------*/
document.addEventListener("DOMContentLoaded", function () {
  const decreaseButton = document.querySelector(".decrease-cta");
  const increaseButton = document.querySelector(".increase-cta");
  const countDisplay = document.querySelector(".count");
  if (countDisplay) {
    let count = parseInt(countDisplay.textContent);

    decreaseButton.addEventListener("click", () => {
      if (count > 1) {
        count--;
        countDisplay.textContent = count;
      }
    });

    increaseButton.addEventListener("click", () => {
      count++;
      countDisplay.textContent = count;
      console.log(countDisplay);
    });
  }
});

/*--------- footer accordion -----------*/
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 991) {
    let footerTitle = document.querySelectorAll(".footer-title");
    let footerSocial = document.querySelectorAll(".social-holder");
    footerSocial.forEach((element) => {
      element.classList.remove("footer-accordion");
    });
    footerTitle.forEach((footerTitle) => {
      footerTitle.addEventListener("click", function (e) {
        let accordion = document.querySelectorAll(".footer-accordion");
        let parentElm = footerTitle.parentElement;
        let siblings = this.nextElementSibling;
        accordion.forEach((element) => {
          element.children[1].style.maxHeight = null;
          element.children[1].style.paddingTop = null;
        });

        parentElm.classList.toggle("active");
        if (parentElm.classList.contains("active")) {
          accordion.forEach((element) => {
            element.classList.remove("active");
          });
          parentElm.classList.toggle("active");
          if (siblings.style.maxHeight) {
            siblings.style.maxHeight = null;
            siblings.style.paddingTop = null;
          } else {
            siblings.style.maxHeight = siblings.scrollHeight + "px";
            siblings.style.paddingTop = "12px";
          }
        }
      });
    });
  }
});

/*--------- country list -----------*/
let input = document.querySelector("#phoneOne");
if (input) {
  const iti = window.intlTelInput(input, {
    separateDialCode: true,
    preferredCountries: ["in"],
  });
}

/*------- form focus -------*/
$(document).ready(function () {
  $(".number-field").focus(function (e) {
    e.preventDefault();
    $(".field.phone-input").css({
      border: "1px solid #9747ff",
      borderRadius: "8px",
    });
    $(".number-field, .flag-field").css("border", "none");
  });

  $(".number-field").blur(function (e) {
    $(".field.phone-input").css({
      border: "1px solid #D9D9D9",
      borderRadius: "8px",
    });
  });
});

/*------- space-btn-tab -------*/
const spaceBtn = document.querySelectorAll(".space-button-wrap .tab-cta");
if (spaceBtn) {
  spaceBtn.forEach(function (btn) {
    btn.addEventListener("click", () => {
      spaceBtn.forEach(function (btn) {
        btn.classList.remove("active");
      });
      btn.classList.add("active");
    });
  });
}

/*------- apply discount cta -------*/
$("#apply-discount-cta").click(function () {
  $("#discount-container").toggleClass("show");
  $("#apply-discount-cta").hide();
  $("#clear-discount-btn").show();
});

$("#clear-discount-btn").click(function () {
  $("#discount-container").toggleClass("show");
  $("#apply-discount-cta").show();
});

/*--------- my account tab -----------*/
// document.addEventListener('DOMContentLoaded', function () {
//   const accountTabLinks = document.querySelectorAll('.my-account-row .detail-tab-list li .account-link');

//   accountTabLinks.forEach(function (link) {
//     link.addEventListener('click', function (event) {
//       event.preventDefault();
//       // if (window.innerWidth <= 991) {
//       //   link.classList.remove('active');
//       // }
//       const getId = link.getAttribute('data-bs-target');
//       const targetPane = document.getElementById(getId);
//       if (targetPane) {
//         document.querySelectorAll('.account-detail').forEach(function (pane) {
//           pane.classList.remove('show');
//         });
//         accountTabLinks.forEach(function (link) {
//           link.classList.remove('active');
//         });
//         targetPane.classList.add('s');
//         this.classList.add('active');
//       }
//     });
//   });
// });

/*------- Modal -------*/
const modalBtn = document.querySelectorAll(".modal-btn");
modalBtn.forEach(function (btn) {
  btn.addEventListener("click", () => {
    const modalId = btn.getAttribute("data-modal-target");
    const targetModal = document.getElementById(modalId);
    targetModal.classList.add("show");
    document.body.classList.toggle("overflowY-hidden");
    var videoSection = document.querySelector(".video-section");
    if (modalId == "video-modal") {
      videoSection.classList.add("relative");
    }
    // targetModal.addEventListener("click", () => {
    //   event.preventDefault();
    //   targetModal.classList.remove("show");
    //   document.body.classList.remove("overflowY-hidden");
    //   videoSection.classList.remove("relative");
    // });
    const closeModal = targetModal.querySelector(".close-modal");
    closeModal.addEventListener("click", () => {
      event.preventDefault();
      targetModal.classList.remove("show");
      document.body.classList.remove("overflowY-hidden");
      videoSection.classList.remove("relative");
    });
  });
});

$(".editAddressLink").click(function () {
  $(".shopify-section-group-header-group").addClass("open-poup-edit");
  $(".shopify-section-group-footer-group").addClass("open-poup-edit");
});

$(".medicair-popup-close").click(function () {
  $(".shopify-section-group-header-group").removeClass("open-poup-edit");
  $(".shopify-section-group-footer-group").removeClass("open-poup-edit");
});

/*--------- my account -----------*/
if (window.innerWidth <= 991) {
  $(".detail-tab-list.mobile .account-link.active").click(function () {
    $(".account-link.active").removeClass("active");
    $(
      ".my-account-section .my-account-row .sidebar-col .detail-tab-list.desktop"
    ).addClass("show");
  });
}

/*--------- product finder wizard -----------*/
$(document).ready(function () {
  $("#pf-next-step").click(function () {
    event.preventDefault();
    $("#pf-step-1").removeClass("active");
    $("#pf-step-2").addClass("active");
  });

  $("#pf-prev-btn").click(function () {
    event.preventDefault();
    $("#pf-step-1").addClass("active");
    $("#pf-step-2").removeClass("active");
  });
});

/*---------login/ logut -----------*/
// $("#forget-cta").click(function () {
//   $("#signin-form").toggle();
// });
// $("#cancel-forget").click(function () {
//   $("#signin-form").toggle();
// });
// $("#reset-cta").click(function () {
//   alert("working");
//   $("#signin-form").toggle();
// });
